import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { ServiceData } from "../data";
const ServiceThree = () => {
 
  let settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="service-area-2 space-bottom">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-7">
            <div className="title-area">
              <span className="sub-title">
                <img src="/assets/img/icon/title_left.svg" alt="shape" />
                Our Services
              </span>
              <h2 className="sec-title style2">Empowering Business
The Excellence</h2>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="service-title-area">
              <p className="">
             Driving innovation and data-driven strategies to help businesses scale efficiently and achieve sustainable growth in a competitive digital world.

              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row gx-30 global-carousel service-slider2">
          <Slider {...settings}>
            {ServiceData.map((item, index)=>{
              return(
 <div className="p-3" key={index}>
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src={item.icon} alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to={item.btnLink}>{item.title}</Link>
                  </h4>
                  <p className="service-box_text">
                    {item.des}
                  </p>
                  <Link
                    to={item.btnLink}
                    className="global-btn style-border"
                  >
                    Read More{" "}
                    <img src="/assets/img/icon/right-icon2.svg" alt="Bizmaster" />
                  </Link>
                </div>
              </div>
            </div>
              )
            })}
           
           
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ServiceThree;
